/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LensPrescription from './lens-prescription';
import LensPrescriptionDetail from './lens-prescription-detail';
import LensPrescriptionUpdate from './lens-prescription-update';
import LensPrescriptionDeleteDialog from './lens-prescription-delete-dialog';

const LensPrescriptionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LensPrescription />} />
    <Route path="new" element={<LensPrescriptionUpdate />} />
    <Route path=":id">
      <Route index element={<LensPrescriptionDetail />} />
      <Route path="edit" element={<LensPrescriptionUpdate />} />
      <Route path="delete" element={<LensPrescriptionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LensPrescriptionRoutes;
